import { lazyload } from 'react-lazyload';
export const lazyloadWrapper = component => lazyload({
  height: 300,
  offset: 100
})(component);